import WhatsappStickersAPI from '../../api/whatsappStickers';

const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isDeleting: false,
  },
};

const getters = {
  getStickers: _state => _state.records,
  uiFlags: _state => _state.uiFlags,
};

// El backend responde los errores de validación en `error`, con el motivo ya
// traducido. Se propaga tal cual para que el picker lo muestre al admin en vez
// de un mensaje genérico.
const errorMessage = error =>
  error?.response?.data?.error || error?.message || '';

const actions = {
  async fetch({ commit }, { searchKey } = {}) {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const { data } = await WhatsappStickersAPI.get({ searchKey });
      commit('SET_STICKERS', data.payload);
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  async create({ commit }, { file, name }) {
    commit('SET_UI_FLAG', { isCreating: true });
    try {
      const { data } = await WhatsappStickersAPI.create({ file, name });
      commit('ADD_STICKER', data);
      return data;
    } catch (error) {
      throw new Error(errorMessage(error));
    } finally {
      commit('SET_UI_FLAG', { isCreating: false });
    }
  },

  async delete({ commit }, id) {
    commit('SET_UI_FLAG', { isDeleting: true });
    try {
      await WhatsappStickersAPI.delete(id);
      commit('REMOVE_STICKER', id);
    } catch (error) {
      throw new Error(errorMessage(error));
    } finally {
      commit('SET_UI_FLAG', { isDeleting: false });
    }
  },
};

const mutations = {
  SET_STICKERS(_state, records) {
    _state.records = records;
  },
  ADD_STICKER(_state, record) {
    _state.records = [record, ..._state.records];
  },
  REMOVE_STICKER(_state, id) {
    _state.records = _state.records.filter(record => record.id !== id);
  },
  SET_UI_FLAG(_state, flags) {
    _state.uiFlags = { ..._state.uiFlags, ...flags };
  },
};

export default { namespaced: true, state, getters, actions, mutations };
